export const environment = {
    production: false,
    apiUrl: 'https://test.zamadev.com/',
    envName: 'test'
};